import React from "react";
import useIsTeam from "./useIsTeam";
import { useRouter } from "next/router";
import useLogout from "./useLogout";
import useProject from "./useProject";

function GenerateRoute(route: string, isTeam?: boolean, team?: string) {
  const router = useRouter();
  return () => {
    const basePath = isTeam ? `/teams/${team}` : "";
    router.push(`${basePath}${route}`);
  };
}

export function useKey(keys: string[], cb?: any) {
  const callbackRef = React.useRef(cb);
  const pressedKeys = React.useRef(new Set());

  React.useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      const tagName = (event.target as HTMLElement)?.tagName.toLowerCase();
      const isInputFocused = tagName === "input" || tagName === "textarea";

      if (!isInputFocused) {
        pressedKeys.current.add(event.code);

        let allKeysPressed = true;
        for (const key of keys) {
          if (!pressedKeys.current.has(key)) {
            allKeysPressed = false;
            break;
          }
        }
        if (allKeysPressed && callbackRef.current) {
          callbackRef.current(event);
        }
      }
    }

    function handleKeyUp(event: KeyboardEvent) {
      pressedKeys.current.delete(event.code);
    }

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
      pressedKeys.current.clear();
    };
  }, [keys]);
}

export const ShortcutKeys = () => {
  const router = useRouter();
  const { isTeam, team } = useIsTeam();
  const logout = useLogout();
  const { project } = useProject(router.query.name as string);
  const projectDomainRef = React.useRef(project?.domain);
  projectDomainRef.current = project?.domain;
  const handleControlLeftEnter = () => {
    const currentProjectDomain = projectDomainRef.current;
    if (currentProjectDomain) {
      const basePath = isTeam ? `/teams/${team}` : "";
      window.open(`${basePath}${currentProjectDomain}`, "_blank");
    }
  };

  useKey(["KeyL"], logout);
  useKey(["KeyB"], GenerateRoute("/domains/new"));
  useKey(["KeyT"], GenerateRoute("/teams/new", isTeam, team));
  // useKey(["KeyP"], GenerateRoute("/projects/new/template", isTeam, team));
  useKey(["KeyG", "KeyP"], GenerateRoute("/projects", isTeam, team));
  useKey(["KeyN"], GenerateRoute("/projects/new", isTeam, team));
  useKey(["KeyD"], GenerateRoute("/domains/register", isTeam, team));
  useKey(["KeyG", "KeyD"], GenerateRoute("/domains", isTeam, team));
  useKey(["KeyG", "KeyT"], GenerateRoute("/teams", isTeam, team));
  useKey(["ControlLeft", "Enter"], handleControlLeftEnter);

  return null;
};
